import { messages } from './messages';
import { urls } from './urls';
import { urlsProd } from './urls.prod';
import { config } from '../assets/config';
import { Servers } from 'src/app/common/enumerations/servers-enum';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  config,
  messages,
  token: '',
  isProduction: config.production,
  productionEnvironment: Servers.PRODUCTION,
  toggle: config.toggle,
  urls: config.production ? urlsProd : urls,
  name: 'ALS Safety Configuration Control',
  mfaURL: 'https://ascc.als.lbl.gov/Shibboleth.sso/Login',
  version: '6.2.6',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
